var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GChart',{ref:"chart",attrs:{"type":"PieChart","data":_vm.valores_entradas_vendidas_grafica,"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }